// extracted by css-extract-rspack-plugin
var _1 = "Kasa8bzE2Q5sCVgw";
export { _1 as "container" }
